//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import uniRate from "@/components/uni-rate/uni-rate.vue"
import formTitle from '@/components/form-title/index.vue'
import uParse from '@/components/gaoyia-parse/parse.vue'
import moreContent from '@/components/more-content/index.vue'
var view, view2, view3, top1, top2, top3
export default {
  data() {
    return {
      imgList: [],
      indicatorDots: false,
      indicatorColor: 'rgba(255, 255, 255, .9)',
      autoplay: true,
      interval: 2000,
      duration: 500,
      current: 1,
      currentLength: 0,
      id: '',
      isWeixin: true,
      isTop: false,
      detail: {},
      scrollTop: 0,
      intoView: '',
      navBarList: [
        { id: 'div1', name: '商品详情' },
        { id: 'div2', name: '使用规则' },
        { id: 'div3', name: '预订须知' }
      ],
      navName: 'div1'
    }
  },
  components: { uniRate, formTitle, uParse, moreContent },
  onLoad(event) {
    this.id = event.id





    this.getDetail()
  },
  onReady() {
    const query = uni.createSelectorQuery().in(this);
    view = query.select("#div1");
    view2 = query.select("#div2");
    view3 = query.select("#div3");
  },
  methods: {
    getDetail() {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/foodBody/queryByProductId',
        data: {
          productId: this.id
        },
      }).then((res) => {
        _this.detail = res.data
        _this.imgList = res.data.images.split(',')
        _this.currentLength = _this.imgList.length
        _this.detail.validStartDate = _this.detail.validStartDate ? moment(_this.detail.validStartDate).format('YYYY-M-DD') : ''
        _this.detail.validEndDate = _this.detail.validEndDate ? moment(_this.detail.validEndDate).format('YYYY-M-DD') : ''
      })
    },
    jump() {
      uni.navigateTo({
        url: '/pages/common/images?image=' + this.imgList
      })
    },
    scroll(e) {
      let _top = e.detail.scrollTop
      let _this = this
      view.boundingClientRect(data => {
        top1 = data.top - 50
      }).exec();
      if (top1 <=0) {
        this.isTop = true
      } else {
        this.isTop = false
      }
      view2.boundingClientRect(function (data) {
        top2 = data.top - 50
      }).exec()
      view3.boundingClientRect(function (data) {
        top3 = data.top - 50
      }).exec()
      if (top1 < 0 && top2 > 0) {
        this.navName = 'div1'
      } else if (top2 <= 0 && top3 > 0) {
        this.navName = 'div2'
      } else if (top3 <= 0) {
        this.navName = 'div3'
      }
      this.intoView = ''
    },
    scrollTo(e) {
      this.navName = e
      this.intoView = e
    },
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    toOrder() {
      // if (this.$isLogin()) {
      uni.navigateTo({
        url: `./submitOrder?id=${this.id}`
      })
      // }
    }
  }
}
